import React from 'react'
import { AdCreative, AssetApprovalStatus } from '@marketing-milk/interfaces'
import { light, radius, status as statusColors, type as typo } from '../tokens'

const schematics: Record<
  AssetApprovalStatus,
  { color: string; label: (reviewer: string) => string }
> = {
  [AssetApprovalStatus.Draft]: { color: light.textFaint, label: () => 'Draft' },
  [AssetApprovalStatus.Pending]: { color: statusColors.warn, label: r => `Pending ${r} Review` },
  [AssetApprovalStatus.Rejected]: { color: statusColors.danger, label: r => `Rejected By ${r}` },
  [AssetApprovalStatus.Approved]: { color: statusColors.success, label: r => `Approved By ${r}` },
  [AssetApprovalStatus.Ready]: { color: statusColors.success, label: () => 'Ready' },
  [AssetApprovalStatus.Published]: { color: statusColors.success, label: () => 'Published' },
}

/**
 * A small colored-dot status pill for the review grid/preview, styled with the
 * same design tokens as the rest of the packet UI rather than the generic
 * Bootstrap badge `CreativeStatus` renders elsewhere (AE editor/present).
 */
export function StatusPill({ creative }: { creative: AdCreative }) {
  const reviewer = creative.reviewType === 'internal' ? 'Staff' : 'Client'
  const { color, label } = schematics[creative.reviewStatus]

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '4px 10px',
        borderRadius: radius.lg,
        background: light.surface,
        border: `1px solid ${light.hairline}`,
        fontFamily: typo.family.sans,
        fontSize: typo.size.eyebrow,
        fontWeight: typo.weight.semibold,
        letterSpacing: '0.02em',
        color: light.text,
        textTransform: 'uppercase',
      }}
    >
      <span
        style={{ width: 7, height: 7, borderRadius: '50%', background: color, flexShrink: 0 }}
      />
      {label(reviewer)}
    </span>
  )
}
